import { Sparkles } from "lucide-react";
import { setHeading, setText } from "../constants/typography";
import { CONTENT } from "../constants/content";
import Reveal from "./ui/Reveal";
import CtaButton from "./ui/CtaButton";
import Callout from "./ui/Callout";
import AlpsWords from "./ui/AlpsWords";
import Emphasis from "./ui/Emphasis";
import AlpsSignature from "./AlpsSignature";
import styles from "../styles/Offerings.module.scss";

const Offerings = () => {
  const { title, description, courseName, subtitle, features, conclusion, cta } =
    CONTENT.offerings;

  return (
    <section id="offerings" className={styles.offerings} aria-label="Il Metodo ALPS">
      {/* --- Editorial header: title left, lead right --- */}
      <div className={styles.header}>
        <Reveal as="h2" className={styles.title} itemProp="name">
          {title.part1}
          <strong>{title.boldPart}</strong>
        </Reveal>

        <Reveal className={styles.headerBody} delay={0.1}>
          <p className={styles.description} itemProp="description">
            {description.map((item, index) =>
              item.type === "bold" ? (
                <Emphasis key={index}>{item.content}</Emphasis>
              ) : (
                <AlpsWords key={index}>{item.content}</AlpsWords>
              )
            )}
          </p>
          <p className={styles.courseName} itemProp="courseName">
            <strong>{courseName}</strong>
          </p>
        </Reveal>
      </div>

      {/* --- A · L · P · S signature, pinned while the principles scroll --- */}
      <div className={styles.methodBlock}>
        <AlpsSignature />

        {/* --- Why it works: editorial numbered list --- */}
        <div className={styles.method}>
        <div className={styles.methodAside}>
          <Reveal as="h3" className={styles.subtitle}>
            {setHeading(subtitle)}
          </Reveal>
          <Reveal className={styles.methodCount} delay={0.1}>
            <span className={styles.methodCountValue}>
              {String(features.length).padStart(2, "0")}
            </span>
            <span className={styles.methodCountLabel}>principi del metodo</span>
          </Reveal>
        </div>

        {/*
          The conclusion lives inside the method column, not after it: the
          aside beside it is sticky, so the heading and the count stay pinned
          through the closing argument and the CTA rather than releasing at
          the last principle.
        */}
        <div className={styles.methodMain}>
          <ol className={styles.featureList}>
            {features.map((feature, index) => (
              <Reveal
                key={feature.name}
                as="li"
                className={styles.featureItem}
                delay={Math.min(index, 4) * 0.06}
                amount={0.35}
              >
                <span className={styles.featureIndex} aria-hidden="true">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <span className={styles.featureIcon}>
                  <img src={feature.iconUrl} alt="" aria-hidden="true" loading="lazy" />
                </span>
                <div className={styles.featureText}>
                  <h4>{setHeading(feature.name)}</h4>
                  <p>{setText(feature.description)}</p>
                </div>
              </Reveal>
            ))}
          </ol>

          {/* --- Conclusion + CTA --- */}
          <div className={styles.outro}>
            <Reveal as="p" className={styles.conclusion}>
              {conclusion.part1}
              <Emphasis>{conclusion.boldPart}</Emphasis>
              {conclusion.part2}
            </Reveal>

            <Reveal delay={0.08} className={styles.calloutWrapper}>
              <Callout label="Nota importante" icon={Sparkles}>
                {setText(conclusion.part3)}
              </Callout>
            </Reveal>

            <Reveal className={styles.ctaWrapper} delay={0.14}>
              <CtaButton to="register">{cta}</CtaButton>
            </Reveal>
          </div>
        </div>
        </div>
      </div>
    </section>
  );
};

export default Offerings;
